<template>
    <div class="my-body">
        <div class="start-destination-class">
            <div class="filghts-line-text" style="color: #FFFFFF;"><span>{{departCity}}</span><img class="min-line-img" src="../../../assets/flights/i_icon_arrows_right3_32px_@2x.m.png"/><span>{{arriveCity}}</span></div>
        </div>
        <div class="head-tab">
            <div class="date-div">
                <div style="display: flex;justify-content: flex-start;align-items: center;">
                    <span class="flights-img-logo" :style="{backgroundPosition:('0 -'+logoPosition+'px')}" ></span>
                    <span class="margin-right-10">{{ezmName}} {{flightNum}}</span>
                    <span class="margin-right-10">{{leaveTime.format('MM-DD')}}</span>
                    <span>周{{weeks[leaveTime.day()]}}</span>
                </div>
            </div>
            <div class="flights-tab-body">
                <div class="time-tab">
                    <div class="start-time">
                        <div class="font-big color-2E3033">{{leaveTime.format('HH:mm')}}</div>
                        <div  class="place-style">{{fromName}}{{fromAirportTower}}</div>
                    </div>
                    <div class="time-line-img">
                      <div style="font-size: 10px;text-align: center;color: #666666;">{{flightDuration}}</div>
                      <img src="../../../assets/flights/i_icon_arrow_150px_@2x.m.png" />
                      <div v-if="stopType === '2'" class="turn-to-stop">
                        <span style="color: #1890ff">停</span>
                        <span>{{stopCitys}}</span>
                      </div>
                      <div v-if="stopType === '3'" class="turn-to-stop">
                        <span style="color: #1890ff">转</span>
                        <span>{{stopCitys}}</span>
                      </div>
                      <div v-if="stopType === '4'" class="turn-to-stop">
                        <span style="color: #1890ff">通程</span>
                        <span>{{stopCitys}}</span>
                      </div>
                    </div>
                    <div class="arrive-time">
                        <div class="font-big color-2E3033">{{arriveTime.format('HH:mm')}}</div>
                        <div  class="place-style">{{toName}}{{toAirportTower}}</div>
                    </div>
                </div>
                <div class="price-parent-div">
                    <div class="flights-tab-end" >
                        <div>
                            <img class="min-img-title" src="../../../assets/flights/airplane.png" />
                            <div>机型：{{plane}}</div>
                        </div>
                        <div v-if="correct">
                            <img class="min-img-title" src="../../../assets/flights/i_icon_time_48px_@2x.m.png" />
                            <div>准点率{{correct}}</div>
                        </div>
                        <div>
                            <img class="min-img-title" v-if="!meal" src="../../../assets/flights/no-food.png" />
                            <img class="min-img-title" v-if="!!meal" src="../../../assets/flights/food.png" />
                            <div v-if="!meal">无餐食</div>
                            <div v-if="!!meal">有餐食</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="loading" style="display: flex;justify-content: center;align-items: center;margin-top: 30px;">
          <van-loading type="spinner" color="#1989fa" />
        </div>
        <flights-query-item  v-for="(item,index) in cabinList" :key="index" :data="item" :cabinMap="cabinMap" :ycPublishPrice="Number(ycPublishPrice)" @viewDetail="gotoDetailsAddPage"></flights-query-item>
    </div>
</template>
<script>
import dayjs from 'dayjs';
import FlightsQueryItem from '../../../components/flights-query-item.vue';

export default {
  components: { FlightsQueryItem },
    data(){
      const {
        from,
        to,
        arriveCity,
        departCity,
        startDate,
        supplierId,
        sys,
        flightNum,
        ezmName,
        plane,
        isShare,
        ycPublishPrice,
        fromName,
        fromAirportTower,
        toName,
        toAirportTower,
        leaveTime,
        arriveTime,
        flightDuration,
        stopCitys,
        stopType,
        logoPosition,
      } = this.$route.query;
        return {
          from,
          to,
          arriveCity,
          departCity,
          startDate: startDate ? dayjs(startDate) : dayjs(),
          supplierId,
          // 数据源：1.去哪儿 2.票候
          sys,
          flightNum,
          ezmName,
          plane,
          isShare,
          ycPublishPrice,
          fromName,
          fromAirportTower,
          toName,
          toAirportTower,
          leaveTime: leaveTime ? dayjs(leaveTime) : dayjs(),
          arriveTime: arriveTime ? dayjs(arriveTime) : dayjs(),
          flightDuration,
          stopCitys,
          stopType,
          logoPosition,

          loading: false,
          cabinDatas: {},
          cabinList: [],
          // 准点率
          correct: '',
          meal: false,
          mealType: '',
          // 购买须知
          buyNotes: '',

          weeks: ['日', '一', '二', '三', '四', '五', '六'],
          cabinMap: {
            F: '头等舱',
            C: '公务舱',
            Y: '经济舱',
            S: '超级经济舱'
          },
        }
    },
    created() {
      this.handleFetchingMoreCabins();
    },
    activated() {
      this.this.handleFetchingMoreCabins();
    },
    methods:{
      // 查看更多报价
      handleFetchingMoreCabins() {
        // 入参
        const params = {
          departCity: this.from,
          arriveCity: this.to,
          flightNum: this.flightNum,
          startDate: this.startDate.format('YYYY-MM-DD'),
          supplierId: this.supplierId,
          sys: this.sys,
          innerTravelFlag: '0'
        }
        // 按钮加载中
        this.loading = true;
        // 获取更多报价
        this.$API.flights
          .getMoreCabins(params)
          .then(res => {
            if (res.code < 300) {
              if (res.data && res.data.cabinList && res.data.cabinList.length > 0) {
                this.cabinDatas = res.data
                this.cabinList = res.data.cabinList;
                this.correct   = res.data.correct;
                this.meal      = res.data.meal;
                this.mealType  = res.data.mealType;
                this.buyNotes  = res.data.buyNotes;
              } else {
                Notify({type: 'success', message: '暂无更多报价'});
              }
            } else {
              Notify({type: 'danger', message: res.msg});
            }
          })
          .catch(err => {
            console.log(err.message);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      gotoDetailsAddPage(data) {
        console.log(data);
        // 下单校验参数
        localStorage.setItem('check_param', data.checkParam);
        localStorage.setItem('business_ext', data.businessExt);
        this.$router.push({
          path: './flights-passenger-add',
          query: {
            from            : this.from,
            to              : this.to,
            supplierId      : this.supplierId,
            fromAirport     : this.fromName,
            toAirport       : this.toName,
            fromAirportTower: this.fromAirportTower,
            toAirportTower  : this.toAirportTower,
            // 直飞
            flightType      : '1',
            // 差旅订票
            innerTravelFlag : '0',
            // 数据源
            sys             : this.sys,
            // 机票信息
            flightNum       : this.flightNum,
            leaveTime       : this.leaveTime.format('YYYY-MM-DD HH:mm:ss'),
            arriveTime      : this.arriveTime.format('YYYY-MM-DD HH:mm:ss'),
            cabin           : data.cabin.cabin,
            publishPrice    : data.publishPrice,
            departCity      : this.departCity,
            arriveCity      : this.arriveCity,
            ezmName         : this.ezmName,
            plane           : this.plane,
            isShare         : this.isShare,
            logoPosition    : this.logoPosition,
            meal            : this.meal,
            flightDuration  : this.flightDuration,
            stopCitys       : this.stopCitys,
            stopType        : this.stopType,
          }
        })
      },
    }
}
</script>
<style scoped>
    .my-body{
        background-image: url("../../../assets/flights/bg-img.png");
        background-size: 100vw auto;
        background-repeat: no-repeat;
        background-color:  #F4F6F9;
        min-height: 100vh;
        padding: 10px 0 50px;
    }
    .color-2E3033{
        color: #2E3033;
    }
    .color-3377FF{
        color: #3377FF;
    }
    .place-style{
        font-size: 13px;
        font-weight: 500;
        color: #5C5F66;
        margin-top:0.25rem;
    }
    .start-destination-class{
        width:100vw;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom:0.5em;
        /* background-color: white; */
        /* position: fixed;
        left: 0;
        top: 0;
        z-index: 199; */
    }
    .filghts-line-text{
        box-sizing: border-box;
        padding:0.25em 0;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        color: #2E3033;
    }

    .time-tab-parent{
        width:11rem;
    }
    .time-tab{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        padding:0 0 0.25rem 0;
    }
    .start-time{
        text-align: start;
        width:auto;
    }
    .arrive-time{
        text-align: start;
        width:auto;
    }
    .time-line-img{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        margin: 0 10px;
    }
    .time-line-img > img{
        width:4rem;
        margin: .5rem 1em;
    }
    .turn-to-stop {
      font-size: 12px;
      text-align: center;
      color: #8a8f99;
      line-height: 12px;
      height: 12px;
    }
    .price-div{
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .price-parent-div{
        width:100%;

    }
    .message-div{
        text-align: end;
    }
    .flights-tab{
        box-sizing: border-box;
        padding: 15px 20px;
        background-color: white;
        margin-top:10px;
    }
    .flights-tab-body{
        background-color: white;
        padding:15px 15px;
        border-radius: 0 0 10px 10px;
    }
    .flights-tab-end {
        display: flex;
        justify-content: start;
        align-items: center;
        color: #8A8F99;
        font-size: 11px;
        margin-top:10px;
    }
    .flights-tab-end > div {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-right:1em;
    }
    .font-big{
        font-size:x-large;
        font-weight: bold;
    }
    .date-div{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background: linear-gradient(270deg, #FFFFFF 0%, #E6EEFF 100%);
        border-radius: 10px 10px 0px 0px;
        height: 44px;
        padding:0 15px;
        font-weight: 500;
        color: #333333;
        font-size: 12px;
    }


    .head-tab{
        border-radius: 10px;
        width:calc( 100% - 20px );
        margin:0 10px;
        /* margin-top:2em; */
        /* overflow:hidden; */
    }
     .min-line-img{
        width:1em;
        margin:0 0.5em;
    }
    .min-img-title{
        width:15px;
        height:15px;
        margin-right:5px;
    }


    .flights-img-logo{
        background:url(https://image.ganyoutong.cn/airline_icon.gif) no-repeat;
        display: inline-block;
        height: 24px;
        line-height: 26px;
        padding-left: 24px;
        margin-right: 5px;
        border-radius: 12px;
        transform: scale(.75);
        transform-origin: 50% 50%;
    }
    .margin-right-10{
        margin-right:10px;
    }
    @media screen and (max-width:374px) {

        .time-line-img > img {
            width: 3rem;
            height: 7px;
            margin: 0 0.25em 0 0.25em;
        }
        .time-tab {
            width: 10.5rem;
        }
    }
</style>
